import { SchemaType } from "../../../yaml-content";
import React from "react";
import SchemaTypeTable from "./schema_type_table";

type Props = {
  schemaType: SchemaType;
  componentSchemas: SchemaType[] | null;
};

const SchemaElementComponent = ({ schemaType, componentSchemas }: Props) => {
  return (
    <div className="sec3 relative">
      <div
        className="anchor absolute inset-0 -z-50 -top-[90px] bottom-[90px] lg:-top-[120px] lg:bottom-[120px]"
        id={`_${schemaType.name}`}
      />
      <h3
        data-adoc-section-id={`_${schemaType.name}`}
        data-adoc-section-title={schemaType.name}
      >
        {schemaType.name}
        <a href={`#_${schemaType.name}`}>
          <svg
            stroke="currentColor"
            fill="currentColor"
            strokeWidth="0"
            viewBox="0 0 24 24"
            height="22"
            width="22"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path fill="none" d="M0 0h24v24H0z"></path>
            <path d="M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"></path>
          </svg>
        </a>
      </h3>
      <div className="flex flex-col ">
        <div className="sect4">
          <SchemaTypeTable
            schemaType={schemaType}
            componentSchemas={componentSchemas}
          />
        </div>
      </div>
    </div>
  );
};

export default SchemaElementComponent;
